// openEHR RM model — BMM package org.openehr.rm.ehr_extract.sync_extract
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { AUDIT_DETAILS } from "../common/generic.ts";
import type { DV_DATE_TIME } from "../data_types/quantity/date_time.ts";
import { MESSAGE_CONTENT } from "./message.ts";
import * as openehr_base from "../../base/mod.ts";
import { applyRmInit, type RmInit } from "../../base/apply_rm_init.ts";

/**
 * Type of request designed for synchronisation of Contributions between openEHR servers.
 */
export class SYNC_EXTRACT_REQUEST extends MESSAGE_CONTENT {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * Details of specification of synchronisation request.
   */
  specification?: SYNC_EXTRACT_SPEC;
}

export class SYNC_EXTRACT extends MESSAGE_CONTENT {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * Details of specification of this Extract.
   */
  specification?: SYNC_EXTRACT_SPEC;
  /**
   * Content, in the form of a serialised Contributions.
   */
  items?: undefined;
}

/**
 * Serialised form of Contribution for an Extract.
 */
export class X_CONTRIBUTION {
  constructor(init?: RmInit) { applyRmInit(this, init); }

  /**
   * Uid of Contribution in source system.
   */
  uid?: openehr_base.HIER_OBJECT_ID;
  /**
   * Audit of Contribution in source system.
   */
  audit?: AUDIT_DETAILS;
  /**
   * Serialised Versions from Contribution in source system.
   */
  versions?: undefined;
}

/**
 * Details of specification of Extract, used in a request to specify an Extract, or in a response, to describe what is actually in the Extract.
 */
export class SYNC_EXTRACT_SPEC {
  constructor(init?: RmInit) { applyRmInit(this, init); }

  /**
   * Internal storage for includes_versions
   * @protected
   */
  protected _includes_versions?: openehr_base.Boolean;

  /**
   * True if the Versions from the Contribution are included; False if just the Contribution and its Audit are included.
   */
  get includes_versions(): boolean | undefined {
    return this._includes_versions?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for includes_versions.
   * Use this to access openehr_base.Boolean methods.
   */
  get $includes_versions(): openehr_base.Boolean | undefined {
    return this._includes_versions;
  }

  /**
   * Sets includes_versions from either a primitive value or openehr_base.Boolean wrapper.
   */
  set includes_versions(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._includes_versions = undefined;
    } else if (typeof val === "boolean") {
      this._includes_versions = openehr_base.Boolean.from(val);
    } else {
      this._includes_versions = val;
    }
  }

  /**
   * List of Contributions to include / that are included in the Extract.
   */
  contribution_list?: undefined;
  /**
   * Specify Contributions included in Extract by threshold date.
   */
  contributions_since?: DV_DATE_TIME;
  /**
   * Internal storage for all_contributions
   * @protected
   */
  protected _all_contributions?: openehr_base.Boolean;

  /**
   * True if all Contributions in the record are included.
   */
  get all_contributions(): boolean | undefined {
    return this._all_contributions?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for all_contributions.
   * Use this to access openehr_base.Boolean methods.
   */
  get $all_contributions(): openehr_base.Boolean | undefined {
    return this._all_contributions;
  }

  /**
   * Sets all_contributions from either a primitive value or openehr_base.Boolean wrapper.
   */
  set all_contributions(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._all_contributions = undefined;
    } else if (typeof val === "boolean") {
      this._all_contributions = openehr_base.Boolean.from(val);
    } else {
      this._all_contributions = val;
    }
  }
}
